export enum PageNumberProps {
  securities = "securitiesPageNumber",
  issuers = "issuersPageNumber"
}
